import { Injectable } from '@angular/core';
import { GEOLOCATION_PERMISSION_QUERY_TIMEOUT } from '@constants/app.constants';

export type GeolocationOptions = {
  enableHighAccuracy?: boolean;
  timeout?: number;
  maximumAge?: number;
};

@Injectable({ providedIn: 'root' })
export class WebApiService {
  constructor() {}

  public checkPermissions(
    name: PermissionName,
    timeout = GEOLOCATION_PERMISSION_QUERY_TIMEOUT,
  ): Promise<PermissionStatus> {
    return new Promise((resolve, reject) => {
      if (!navigator.permissions) {
        return reject(new Error('navigator.permissions not available'));
      }

      Promise.race([
        navigator.permissions.query({ name }),
        new Promise<never>((_, reject) =>
          setTimeout(
            () => reject(new Error('Permission check timed out')),
            timeout,
          ),
        ),
      ])
        .then(resolve)
        .catch(reject);
    });
  }

  public getCurrentPosition(
    options: GeolocationOptions,
  ): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => resolve(position),
        (error) => reject(new Error(error.message)),
        options,
      );
    });
  }
}
